import { connect } from "react-redux";
import SocialActivityDeletor from "../components/SocialActivityDeletor";
import { fetchGroups, sendAlert } from "../actions";
var mapStateToProps = function(state, _ownProps) {
    return {
        users: state.session ? state.users.filter(function(u) {
            var _state_session;
            return u.id !== ((_state_session = state.session) === null || _state_session === void 0 ? void 0 : _state_session.id);
        }) : []
    };
};
var mapDispatchToProps = function(dispatch, _ownProps) {
    return {
        fetchGroups: function() {
            dispatch(fetchGroups());
        },
        sendAlert: function(message, messageType, timeout) {
            dispatch(sendAlert({
                message: message,
                messageType: messageType,
                timeout: timeout
            }));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(SocialActivityDeletor);
